import React, { useState } from 'react';
import {buildImageObj, imageUrlFor} from './sanity/image-url';
import Icon from './icon';

function SlideDeck(props) {
    const [currentSlide, setCurrentSlide] = useState(0);

    const prevSlide = () => {
        if (currentSlide > 0) {
            if (typeof window !== 'undefined' && 'ga' in window) {
                window.ga('send', 'event', 'Slide Deck', 'click', props.title, props.deck.slides[currentSlide - 1].title);
            }
            setCurrentSlide(currentSlide - 1);
        }
    }

    const nextSlide = () => {
        if (currentSlide < (props.deck.slides.length - 1)) {
            if (typeof window !== 'undefined' && 'ga' in window) {
                window.ga('send', 'event', 'Slide Deck', 'click', props.title, props.deck.slides[currentSlide + 1].title);
            }
            setCurrentSlide(currentSlide + 1);
        }
    }

    return (
        <div className='slideDeck'>
            <div className='slideDeck__slides'>
                {props.deck.slides.map((slide, slideIndex) => (
                    <div key={slideIndex} className={`slideDeck__slide${slideIndex === currentSlide ? ' active' : ''}`}>
                        <figure className="slideDeck__slide__media">
                            {slide.slide && slide.slide.asset && (
                                <img className="slideDeck__slide__img lazy" src={imageUrlFor(buildImageObj(slide.slide)).width(1024).height(576)} alt={slide.title} />
                            )}
                        </figure>
                    </div>
                ))}
            </div>
            <div className='slideDeck__controls'>
                {/* <div className='slideDeck__share'>
                    <Icon symbol="share" />
                </div> */}
                <div className='slideDeck__paging'>
                    <span className='arrow' onClick={() => prevSlide()} rel="presentation"><Icon symbol="arrow-left" /></span>
                    <span className='number'>{currentSlide + 1}</span> of <span className='number'>{props.deck.slides.length}</span>
                    <span className='arrow' onClick={() => nextSlide()} rel="presentation"><Icon symbol="arrow-right" /></span>
                </div>
                {/* <div className='slideDeck__viewing'>
                    <Icon symbol="fullscreen" />
                </div> */}
            </div>
        </div>
    );
}

export default SlideDeck;
